export const FORMS_MAIL_CREATE = 'mailboxCreate';
export const FORMS_TRANSFER_CONTACT_INFO = 'transferContactInfo';
export const BOOKING_FORM_NAME = 'bookingContactInfo';
